import ol_geom_Polygon from 'ol/geom/Polygon';
import { BUFFER_AREA } from '../../utils/styles/styles';
import SingleFeature from './Singlefeature';

/**
 * A layer which draw a buffer (circle, polygon, sector...).
 * @constructor
 * @extends {SingleFeature}
 * @param {Object} options Control options, extends olx.layer.VectorOptions.
 */
export default class Buffer extends SingleFeature {
  constructor(options = {}) {
    options.style = options.style || BUFFER_AREA;
    super(options);
  }

  /**
     * Sugar to draw a sector.
     * @param {import("ol/coordinate").Coordinate} coordinate The sector coordinate.
     * @param {number} length The sector length.
     * @param {number} radius The sector radius.
     * @param {number} heading The sector heading.
     */
  drawSector(coordinate, length, radius, heading) {
    // Create start and and angle of the sector arc.
    const deltaToNordHeading = Math.PI / 2;
    const startAngle = -radius / 2 + deltaToNordHeading + heading;
    const endAngle = radius / 2 + deltaToNordHeading + heading;

    // Center coords
    const xCent = coordinate[0];
    const yCent = coordinate[1];

    const list = [];
    if (radius != 2 * Math.PI) {
      list.push(coordinate);
    }
    for (let i = startAngle; i < endAngle; i += 0.01) {
      list.push([xCent + length * Math.cos(i), yCent + length * Math.sin(i)]);
    }
    if (radius != 2 * Math.PI) {
      list.push(coordinate);
    } else {
      list.push([xCent + length * Math.cos(startAngle), yCent + length * Math.sin(startAngle)]);
    }

    // Create the sector geometry.
    this.drawPolygon(new ol_geom_Polygon([list]));
  }

  /**
     * Sugar to draw a circle.
     * @param {import("ol/coordinate").Coordinate} center The circle center.
     * @param {number} radius The circle radius.
     */
  // eslint-disable-next-line no-unused-vars
  drawCircle(center, radius) {}
}
